export default __webpack_public_path__ + "static/media/30.8fbdfca2.jpg";